'use client';

import type { ComponentProps } from 'react';
import type { UseEducationalTutorialReturn } from '../../hooks/useEducationalTutorial';

type EducationalTutorialProgressProps = ComponentProps<'div'> & {
  tutorial: UseEducationalTutorialReturn;
};

function EducationalTutorialProgress({ tutorial, className, ...props }: EducationalTutorialProgressProps) {
  return (
    <div role="status" aria-live="polite" aria-label={tutorial.progressText} className={className} {...props}>
      <span className="paragraph-explanatory-strong">{tutorial.currentStep}</span>
      <span className="paragraph-explanatory-strong text-foreground-subtle pl-1" data-testid="educational-tutorial-progress-total">
        /{tutorial.totalSteps}
      </span>
    </div>
  );
}

export { EducationalTutorialProgress };
